export const panamaPapers = {
  id: "panama-papers",
  thumbnailUrl: "../assets/Panama_Papers/00-PP-1x1.webp",
  disciplines: "Editorial",
  year: "2021",
  project: "The Panama Papers",
  initiatedAt: "HSLU Lucerne, CH (Exchange)",
  shortInitiatedAt: "HSLU, CH",
  description:
    '"Panama Papers" is a typographic editorial project engaging with investigative journalism and its political weight. The publication explores how layout can influence perception and reading behavior, using structure and rhythm to make the complexity and gravity of the content tangible beyond the written word.',
  credits: [
    "Initiated at BA Graphic Design, HSLU Lucerne, Switzerland",
    "Mentoring Tiziana Artemisio, Mirko Leuenberger",
  ],
  galleryItems: [
    {
      medias: [
        {
          type: "image",
          url: "/assets/Panama_Papers/01-PP-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg portrait-media-nine-by-ten",
        },
        {
          type: "image",
          url: "/assets/Panama_Papers/02-PP-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: "The cover condenses the chapter into one image, a metaphorical summary of the Panama Papers.",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Panama_Papers/03-PP-1x1-1080.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-four-lg square-media-one-by-one",
        },
        {
          type: "video",
          sound: true,
          url: "/assets/Panama_Papers/04-PP-1x1-Video.mp4",
          poster: "/assets/Panama_Papers/04-PP-1x1-Video_thumbnail.webp",
          classNames:
            "start-one-sm span-four-sm start-six-lg span-seven-lg square-media-one-by-one",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Panama_Papers/05-PP-16x9-2560.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-twelve-lg landscape-media-sixteen-by-nine",
        },
      ],
      description: {
        text: "The size of type reflects how often names appear in the Panama Papers",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "video",
          sound: true,
          url: "/assets/Panama_Papers/06-PP-1x1-Video.mp4",
          poster: "/assets/Panama_Papers/06-PP-1x1-Video_thumbnail.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-four-lg square-media-one-by-one",
        },
        {
          type: "image",
          url: "/assets/Panama_Papers/07-PP-1x1-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-six-lg span-seven-lg square-media-one-by-one",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Panama_Papers/08-PP-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg portrait-media-nine-by-ten",
        },
        {
          type: "image",
          url: "/assets/Panama_Papers/09-PP-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
  ],
};
